/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [cover-slider.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 11.12.19, 12:54
 */
import React from 'react';
import {getImageServerFullUrl} from "../../actions/environment";
import SwiperContainer from "./swiper-container";
import {SwiperSlide} from "swiper/react";

const CoverSlider = ({space, lazy = false}) => {

    const renderSlides = (slides) => {
        return slides.map(slide => {
            return <SwiperSlide key={slide.id}>
                <img data-src={getImageServerFullUrl(slide.url)}
                     className={`cover-img fit-cover ${lazy ? 'swiper-lazy' : ''}`} alt=''/>
                {lazy && <div className='swiper-lazy-preloader'/>}
            </SwiperSlide>
        })
    }

    if (!space || !space.media) return null;
    return <SwiperContainer lazy={lazy} autoplay={{delay: 4000}}>
        {renderSlides(space.media)}
    </SwiperContainer>
}

export default CoverSlider;